<div class="external-login">
  <!-- Show spinner without container when loading -->
  <div class="loading-spinner-wrapper" *ngIf="isLoading">
    <p-progressSpinner styleClass="login-spinner"></p-progressSpinner>
  </div>
  
  <!-- Show login form with container when not loading -->
  <div class="login-container" *ngIf="!isLoading">
    <div class="form-group">
      <img [src]="'assets/NLeafLogo.png'" />
      <div class="input-container">
        <button class="button" type="button" (click)="login()">Login</button>
      </div>
      <div class="build-info">{{ buildNumber }}</div>
    </div>
  </div>
</div>
